import React from 'react';
import { siteContent } from '../data/mock';

const Header = () => {
  const { brand } = siteContent;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-neutral-100">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center">
          <img 
            src={brand.logo} 
            alt={brand.name} 
            className="h-8 w-auto"
          />
        </a>
        <a 
          href={brand.loginUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-neutral-600 hover:text-neutral-900"
        >
          Login
        </a>
      </div>
    </header>
  );
};

export default Header;
